// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1InvoiceSchema } from './v1/invoiceSchema';
import { v1InvoicesUpdateSchema } from './v1/invoices/updateSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const updateInvoicePathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  id: z.number().int().describe("Invoice ID"),
});

export const updateInvoiceHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Invoice updated
 */
export const updateInvoice200Schema = z.lazy(() => v1InvoiceSchema);

/**
 * @description Unauthorized
 */
export const updateInvoice401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Invoice not found
 */
export const updateInvoice404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Validation errors
 */
export const updateInvoice422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateInvoiceMutationRequestSchema = z.lazy(() => v1InvoicesUpdateSchema);

export const updateInvoiceMutationResponseSchema = z.lazy(() => updateInvoice200Schema);
